<template>
  <div>
    <div style="position: relative">
      <img
        v-if="!hideImage"
        src="/images/qatar2022_icon.gif"
        class="block-image"
        alt=""
      />
      <div class="home-banner-box">
        <iframe
          src="https://player.restream.io/?token=348213aa8c2d41c8b89000227ef9741e&vwrs=1"
          allowfullscreen
          frameborder="0"
          class="qatar-live-2022-iframe"
        >
        </iframe>
      </div>
    </div>
    <div class="text-center">
      <img
        src="/images/qatar/live.jpg"
        class="img-qatar-live"
        alt=""
        style="max-wdith: 100%"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "AppQatarWorldCup2022",
  data: () => ({
    hideImage: false,
  }),
  created() {
    var closeFunction = this.hideImageIcon;
    setTimeout(function () {
      closeFunction();
    }, 3000);
  },
  methods: {
    hideImageIcon() {
      this.hideImage = true;
    },
  },
};
</script>

<style lang="scss">
.qatar-live-2022-iframe {
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 80vh;
}
.home-banner-box {
  height: auto;
  position: relative;
  margin-top: 130px;
  .home-banner-carousel {
    height: 100% !important;
    width: 100%;
  }
}

.img-qatar-live {
  max-width: 100%;
}

.block-image {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  max-width: 300px;
}

@media (max-width: 959px) {
  .home-banner-box {
    margin-top: 115px;
  }
}

@media (max-width: 599px) {
  .home-banner-box {
    margin-top: 115px;
  }

  .qatar-live-2022-iframe {
    height: 70vw;
  }

  .block-image {
    max-width: 200px;
  }
}
@media (max-width: 425px) {
  .home-banner-box {
    margin-top: 95px;
  }
}
</style>
